<script lang="ts">
  import type { Snippet } from 'svelte';

  let { case_number, stage, children } : { case_number? : string; stage? : string; children : Snippet } = $props()
</script>

{#if case_number || stage}
  <div class="rounded bg-gradient-to-b from-gray-200 to-gray-100 px-px -mx-px">
    <div class="flex justify-between gap-4 px-4 lg:px-6 pb-1 pt-1.5 text-sm text-gray-800">
      <div class="whitespace-nowrap font-bold">{case_number}</div>
      {#if stage}<div class="truncate font-medium">{stage}</div>{/if}
    </div>
    {@render children()}
  </div>
{:else}
  {@render children()}
{/if}
